.products-page {
  // 与 Home / AboutUs 保持一致的容器与断点策略
  --content-max: 1500px;
  --container-pad: clamp(16px, 4vw, 48px);
  --tap-min: 44px;
  --section-gap: clamp(32px, 4.5vw, 56px);

  .page {
    width: 100%;
    min-height: 100%;
    background-color: rgba(255, 255, 255, 1);
  }

  // ---------------------------------------------------------------------------
  // Hero
  // ---------------------------------------------------------------------------
  .products-hero {
    position: relative;
    width: 100%;
    min-height: clamp(620px, 78vh, 920px);
    background: url(../../assets/images/pages-products-products-hero.png) no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
  }

  .products-hero__overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(22, 0, 4, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .products-hero__content {
    width: min(92vw, var(--content-max));
    padding: 0 var(--container-pad);
    box-sizing: border-box;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0;
  }

  .products-hero__title {
    margin: 0;
    width: min(92vw, 24ch);
    color: rgba(255, 255, 255, 1);
    font-size: clamp(32px, 4.5vw, 80px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: center;
    line-height: 1.02;
    white-space: normal;
  }

  .products-hero__lead {
    margin: 0;
    width: min(92vw, 92ch);
    color: rgba(255, 255, 255, 1);
    font-size: clamp(15px, 1.4vw, 18px);
    font-family: Red Rose-Light;
    font-weight: 300;
    text-align: center;
    line-height: 1.75;
  }

  // ---------------------------------------------------------------------------
  // Main
  // ---------------------------------------------------------------------------
  .products-main {
    width: 100%;
  }

  .products-main__title {
    margin: clamp(64px, 10vw, 160px) auto 0;
    padding-inline: var(--container-pad);
    box-sizing: border-box;
    max-width: var(--content-max);
    text-transform: uppercase;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(40px, 6vw, 80px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: center;
    line-height: 1;
  }

  .products-collections {
    width: 100%;
    margin: clamp(40px, 6vw, 120px) auto 0;
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .product-feature {
    width: 100%;
    background-color: rgba(239, 236, 229, 1);
    display: grid;
    grid-template-columns: 1.35fr 1fr;
    align-items: stretch;
    min-height: clamp(420px, 38vw, 675px);
  }

  .product-feature__media {
    position: relative;
    min-height: 240px;
    overflow: hidden;
  }

  .product-feature__image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  .product-feature__body {
    padding: clamp(24px, 3.5vw, 56px) var(--container-pad);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: clamp(16px, 2.2vw, 24px);
  }

  .product-feature__title {
    margin: 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(28px, 3.2vw, 48px);
    font-family: Red Rose-Medium;
    font-weight: 500;
    text-align: left;
    line-height: 1.1;
    max-width: 28ch;
  }

  .product-feature__desc {
    margin: 0;
    color: rgba(124, 124, 124, 1);
    font-size: 16px;
    font-family: PingFang SC-Regular;
    font-weight: normal;
    text-align: left;
    line-height: 1.75;
    white-space: pre-line;
    max-width: 78ch;
  }

  .product-feature__cta {
    margin-top: clamp(6px, 1.2vw, 18px);
    width: fit-content;
    min-height: var(--tap-min);
    padding: 12px 16px;
    border-radius: 10px;
    border: 2px solid rgba(22, 0, 4, 1);
    background: transparent;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    transition:
      background-color 0.2s ease,
      transform 0.2s ease;

    &:hover {
      background-color: rgba(22, 0, 4, 0.06);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .product-feature__ctaLabel {
    color: rgba(22, 0, 4, 1);
    font-size: 16px;
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: left;
    line-height: 1;
    white-space: nowrap;
    text-transform: uppercase;
  }

  .product-feature__ctaIcon {
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .product-feature__ctaArrow {
    width: 18px;
    height: 18px;
    display: block;
  }

  .product-feature--reversed {
    grid-template-columns: 1fr 1.35fr;

    .product-feature__media {
      order: 2;
    }
  }

  // ---------------------------------------------------------------------------
  // Upcoming notice
  // ---------------------------------------------------------------------------
  .products-upcoming {
    width: 100%;
    max-width: var(--content-max);
    margin: clamp(72px, 12vw, 180px) auto clamp(64px, 10vw, 160px);
    padding-inline: var(--container-pad);
    box-sizing: border-box;
    text-align: center;
  }

  .products-upcoming__title {
    margin: 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(30px, 4vw, 56px);
    font-family: Red Rose-Medium;
    font-weight: normal;
    text-align: center;
    line-height: 1.05;
    white-space: normal;
    text-transform: uppercase;
  }

  .products-upcoming__text {
    margin: clamp(16px, 3.5vw, 40px) auto 0;
    max-width: min(92ch, 100%);
    color: rgba(124, 124, 124, 1);
    font-size: clamp(16px, 1.6vw, 24px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: center;
    line-height: 1.7;
  }

  // ---------------------------------------------------------------------------
  // Breakpoints
  // ---------------------------------------------------------------------------
  @media (max-width: 1023px) {
    .products-hero {
      min-height: clamp(580px, 74vh, 760px);
    }

    .products-collections {
      gap: 16px;
      padding-inline: var(--container-pad);
      box-sizing: border-box;
    }

    .product-feature,
    .product-feature--reversed {
      grid-template-columns: 1fr;
      border-radius: 16px;
      overflow: hidden;
    }

    .product-feature--reversed .product-feature__media {
      order: 0;
    }

    .product-feature__body {
      padding: clamp(20px, 4.5vw, 32px);
    }
  }

  @media (max-width: 767px) {
    .products-hero {
      min-height: clamp(540px, 70vh, 680px);
    }

    .product-feature__title {
      max-width: 22ch;
    }

    .product-feature__cta {
      width: 100%;
      justify-content: space-between;
    }
  }
}
